import * as tags from './tags'

import ControllerClass from './Controller'
import { DEPRECATE } from './utils'
import ModuleClass from './Module'
let tagsVar = tags

if (
  process.env.NODE_ENV !== 'production' &&
  typeof global.Proxy !== 'undefined'
) {
  tagsVar = Object.keys(tags).reduce((proxyHost, key) => {
    proxyHost[key] = new Proxy(tags[key], {
      get(_obj, _prop) {
        throw new Error('YOU HAVE NOT ENABLED THE @CEREBRAL/BABEL-PLUGIN')
      },
    })

    return proxyHost
  }, {})
}

export const props = tagsVar.props
export const path = tagsVar.path
export const state = tagsVar.state
export const string = tagsVar.string
export const sequences = tagsVar.sequences
export const moduleState = tagsVar.moduleState
export const moduleSequences = tagsVar.moduleSequences

// Needed to test for instanceof.
export { default as ModuleClass } from './Module'
export { default as ControllerClass } from './Controller'
export { default as ProviderClass } from './Provider'
export { default as BaseControllerClass } from './BaseController'

export {
  SequenceFactory as ChainSequenceFactory,
  SequenceWithPropsFactory as ChainSequenceWithPropsFactory,
} from 'function-tree/fluent'

export {
  sequence,
  parallel,
  createTemplateTag,
  extractValueWithPath,
  resolveObject,
  ResolveValue,
  Tag,
} from 'function-tree'

export function Controller(rootModule, options) {
  DEPRECATE('Controller', 'Use App default import instead')
  return new ControllerClass(rootModule, options)
}

export function UniversalController(rootModule, options) {
  DEPRECATE('UniversalController', 'Use UniversalApp import instead')
  const UniversalControllerClass = require('./UniversalController').default
  return new UniversalControllerClass(rootModule, options)
}

export function UniversalApp(rootModule, options) {
  const UniversalControllerClass = require('./UniversalController').default
  return new UniversalControllerClass(rootModule, options)
}

export function Module(definition) {
  DEPRECATE(
    'Module',
    'Use plain object/function. Type with ModuleDefinition export'
  )
  return new ModuleClass(definition)
}

export { default as CerebralError } from './CerebralError'
export { default as Provider } from './Provider'
export { default as Compute } from './Compute'
export { default as Reaction } from './Reaction'

export { default as View } from './View'
export { createDummyController, throwError } from './utils'

let existingInstance
export default function App(rootModule, options) {
  if (
    process.env.NODE_ENV === 'development' &&
    existingInstance &&
    (!options || options.hotReloading === undefined)
  ) {
    console.warn(
      'Cerebral has detected HOT RELOADING in your app. It is recommended that you add the option "hotReloading" and set it to true. Set it to false to turn off this message and let it fly'
    )
  }

  if (options && options.hotReloading === true && existingInstance) {
    existingInstance.reconfigure(rootModule)

    return existingInstance
  }

  return (existingInstance = new ControllerClass(rootModule, options))
}
